import Box from "@mui/material/Box";
import { FC } from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { richTextStyles } from "./rich-text-styles";
import { sanitizeHtml } from "../lib/sanitization";

export const RichTextRenderer: FC<{ contents: string }> = ({ contents }) => {
	const sanitizedContents = sanitizeHtml(contents, {
		ALLOWED_TAGS: [
			"a",
			"b",
			"blockquote",
			"br",
			"code",
			"div",
			"em",
			"h1",
			"h2",
			"h3",
			"h4",
			"h5",
			"h6",
			"hr",
			"i",
			"img",
			"li",
			"ol",
			"p",
			"pre",
			"span",
			"strong",
			"table",
			"tbody",
			"td",
			"th",
			"thead",
			"tr",
			"u",
			"ul",
		],
		ALLOWED_ATTR: ["alt", "href", "rel", "src", "target", "title"],
	});

	return (
		<Box
			sx={{
				overflowWrap: "anywhere",
				...richTextStyles,
			}}>
			<Markdown rehypePlugins={[rehypeRaw]}>{sanitizedContents}</Markdown>
		</Box>
	);
};
